<template>
  <div v-if="isFirstRender" class="basket-mobile _stub">
    <loader-block text="Загружаем вашу корзину" />
  </div>
  <layout-page
      v-else
      class="basket-mobile"
      :show-sidebar="showSidebar"
      :current-tab="currentTab"
      :amount="amount"
      :is-deleted-all="isDeletedAllTab"
      :show-total-button="isBasket && !isEmptyBasket"
      :is-loading="isLoadingChangeAllItems"
      :unavailable-items-length="unavailableItemsLength"
      @changeTab="handleChangeTab"
      @clickButtonGoCheckout="handlerClickButtonGoCheckout"
  >
    <template #default>
      <empty-basket
          v-if="showEmptyComponent"
          :is-basket="isBasket"
          :is-authorized="isAuthorized"
          :is-empty-wish-list="isEmptyWishList"
          @changeTab="handleChangeTab"
          @openAuthModal="handlerOpenAuthModal"
      />
      <template v-else>
        <count-items
            class="basket-mobile__content-holder"
            :count="countInTab"
            :is-loading="isLoadingFetchProductsWishList"
        />
        <div v-if="isBasket">
          <div v-if="isUaOrGb" class="basket-mobile__content-holder basket-mobile__delivery-info">
            <notification type="error" class="">
              Доставка недоступна в Великобританию и Украину
            </notification>
          </div>
          <div v-if="showDeliveryInfo" class="basket-mobile__content-holder basket-mobile__delivery-info">
            <side-bar-delivery-free
                class="basket-mobile__content-holder basket-desktop__delivery-info"
                :cheapest-deliveries="cheapestDeliveries"
                :optimal-delivery-data="optimalDeliveryData"
                :is-has-free-delivery="isHasFreeDelivery"
                :is-deleted-all="isDeletedAllTab"
                :amount="amount"
                :is-loading="isLoadingFetchBasket"
            />
          </div>
          <basket-list
              :items="basketItems"
              :is-authorized="isAuthorized"
              :is-loading="isLoadingChangeAllItems"
              :show-change-gift="showChangeGift"
              :unavailable-items-length="unavailableItemsLength"
              @moveToWishList="handlerMoveToWishList"
              @removeItem="handlerRemoveItem"
              @spliceItem="handlerSpliceItem"
              @restoreItem="handlerRestoreItem"
              @updateQuantityItem="handlerUpdateQuantityItem"
              @openAuthModal="handlerOpenAuthModal"
              @clickNotAvailable="handlerClickNotAvailable"
              @clickChangeGift="handlerClickChangeGift"
              @clickDeleteUnavailable="handlerRemoveUnavailable"
          />
        </div>
        <wish-list
            v-else
            :items="wishList"
            :is-loading="isLoadingFetchProductsWishList"
            :is-may-load-more="isMayLoadMoreWishList"
            :show-skeleton="showSkeletonWishList"
            @changeTab="handleChangeTab"
            @loadMoreWishList="handlerLoadMoreWishList"
            @spliceWishItem="handlerSpliceWishItem"
            @restoreWishItem="handlerRestoreWishItem"
            @removeWishItem="handlerRemoveWishItem"
            @addToBasketItem="handlerAddToBasket"
            @clickNotAvailable="handlerClickNotAvailable"
        />
      </template>
    </template>
    <template #sidebar>
      <basket-summary
          :amount="amount"
          :discount-amount="discountAmount"
          :quantity="quantity"
          :weight="weight"
          :cashback="cashback"
          :cheapest-deliveries="cheapestDeliveries"
          :is-loading="isLoadingFetchBasket"
          :is-deleted-all="isDeletedAllTab"
          :max-pay-bonuses="availableBonuses"
          @changePromoCode="handlerUpdateBasket"
      />
    </template>
  </layout-page>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { LoaderBlock, Notification } from '@book24/ui-components';

import useBasketPage from '@/compositions/useBasketPage';

import LayoutPage from '@/components/_mobile/LayoutPage/index.vue';
import SideBarDeliveryFree from '@/components/SideBarDeliveryFree/index.vue';
import EmptyBasket from '@/components/_mobile/EmptyBasket/index.vue';
import CountItems from '@/components/_mobile/CountItems/index.vue';
import BasketSummary from '@/components/_mobile/BasketSummary/index.vue';
import BasketList from '@/components/_mobile/BasketList/index.vue';
import WishList from '@/components/_mobile/WishList/index.vue';

export default defineComponent({
  name: 'MobilePage',
  components: {
    LayoutPage,
    LoaderBlock,
    Notification,
    SideBarDeliveryFree,
    EmptyBasket,
    CountItems,
    BasketSummary,
    BasketList,
    WishList,
  },
  setup() {
    const basketPage = useBasketPage();
    return {
      ...basketPage,
    };
  },
  head: {},
});
</script>

<style lang="less" src="../src/assets/styles/chunks/mobile/common.less"></style>
<style lang="less">
.basket-mobile {
  .container-m();

  padding: @size-x3 0 @size-x10;

  &._stub {
    min-height: 200px;
  }

  &__content-holder {
    padding-left: @size-x4;
    padding-right: @size-x4;
  }

  &__delivery-info {
    margin-top: @size-x2;
  }
}
</style>
